"use client"
import React, { useState } from 'react';
import {
    Typography,
    Stack,
    TextField,
    Button,
} from "@mui/material";
import { postMethod } from '../../../services/apiService';
interface Props {
    setResetPassword: (password: boolean) => void;
    resetPassword: boolean;
    setSuccessMail: (password: boolean) => void;
    setUserId:any
}
//import { getResetLink } from '@/utils/apis/resetPassword/resetPassword';


const ResetPassword: React.FC<Props> = ({ setResetPassword, resetPassword, setSuccessMail,setUserId }) => {
    const [emailToResetPassword, setEmailToResetPassword] = useState('');
    const [resetEmail, setResetEmail] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    // Function to handle email change
    const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEmailToResetPassword(e.target.value);
        const isValidEmail = validateEmail(e.target.value);
        console.log(e.target.value.length);
        if(e.target.value.length===0){
            setResetEmail(false);
        }else{
            setResetEmail(!isValidEmail);
        }
        setErrorMsg('');
    };

    // const location = useLocation();
    // Function to request reset link
    const requestResetLink = async (e: React.FormEvent<HTMLButtonElement>) => {
        e.preventDefault();
        // Validate reset email 
        if (resetEmail) {
            setErrorMsg('The email you entered is incorrect!');
        } else if (emailToResetPassword === '') {
            setErrorMsg('Please enter email');
            setResetEmail(true);
        } else {
             let a = window.location.href;
             console.log(a);
             
             let b= a.split('forgot-password');
             console.log(b);
             
             let path = b[0]+'reset-password?uk='
             let payload={
                userid : emailToResetPassword,
                redirecturl : path
            }
            console.log(payload);

            const resp = await postMethod("forgot/password/generatelink", payload);
            if(resp?.status === 200) {
                setUserId(emailToResetPassword);
                setErrorMsg('');
                setEmailToResetPassword('');
                setResetPassword(!resetPassword);
                setSuccessMail(true);
                // Set success mail to false after 2 seconds
                setTimeout(() => {
                    setSuccessMail(false);
                }, 2000);
            } else {
                setErrorMsg(resp?.data?.message);
            }
             /* getResetLink(data).then((data: any) =>{
                if(data.code===200){
                    setUserId(emailToResetPassword);
                    setErrorMsg('');
                    setEmailToResetPassword('');
                    setResetPassword(!resetPassword);
                    setSuccessMail(true);
                    // Set success mail to false after 2 seconds
                    setTimeout(() => {
                        setSuccessMail(false);
                    }, 2000);
                }else{
                    setErrorMsg(data.message);
                }
             }) */
            
        }
    };

    // Function to validate email
    const validateEmail = (email: string) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    return (
        <Stack>
            <Typography
                sx={{
                    fontFamily: 'Inter',
                    fontWeight: 500,
                    fontSize: "24px",
                    mb: '24px',
                }}
            >
                Forgot Password?
            </Typography>

            <Typography
                sx={{
                    mb: '24px',
                    fontSize: '14px',
                    textAlign: 'center',
                    color: '#FB462E'
                }}
            >
                {errorMsg}
            </Typography>

            <TextField
                variant="outlined"
                placeholder='Email'
                type={'email'}
                InputProps={{
                    sx: {
                        color: '#E2E3E3',
                        '& fieldset': {
                            border: '1px solid #313838'
                        },
                        '& input::placeholder': {
                            color: '#B4B7B8',
                        },
                        padding: '0px 15px',
                        borderRadius: '8px',
                        fontSize: '16px',
                        mb: '24px',
                    },
                }}
                sx={{
                    "& .MuiOutlinedInput-root": {
                        "&.Mui-focused fieldset": {
                            borderColor: '#313838'
                        }
                    }
                }}
                onChange={handleEmailChange}
                value={emailToResetPassword}
                error={resetEmail}
            />
            <Button type="submit" variant="contained" sx={{ padding: '12px 16px', mb: '24px', fontSize: '14px', fontWeight: 500 }} className='auth-btn' onClick={requestResetLink}>
                Request Reset Link
            </Button>
        </Stack>
    )
}

export default ResetPassword;
